module.exports = "<div style=\"text-align: center\">\n    <h1>Your account is suspended</h1>\n    <h2>If you have any questions please contact our support</h2>\n\n    <div class=\"Info-contacts\" style=\"margin-top: 50px\">\n        <sa-support-email\n                class=\"Link--blue\"\n                sa-contact-button>\n        </sa-support-email>\n    </div>\n\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/src/directives/suspended.html
// module id = 507
// module chunks = 24